import styled, { css } from 'styled-components';

import { QuestionDisplayMode } from '../CircleText/CircleText';
import { colorsV2 } from '../colors-v2';

export const QuestionBoxWrapper = styled.div<{
  isMatching?: boolean;
}>`
  background: ${colorsV2.white100};
  font-size: 14px;
  box-sizing: border-box;
  border-radius: 8px;
  display: inline-flex;
  line-height: 20px;
  color: ${colorsV2.black100};
  align-items: center;
  padding: 4px;

  .row {
    display: flex;
    align-items: center;
    .question-option {
      margin-right: 8px;
      border: 1px dashed ${colorsV2.gray60};
    }
  }
  &.dropable {
    padding: 4px 8px 4px 4px;
    color: ${colorsV2.gray80};
    font-weight: 400;
    border: 1px solid transparent;
  }
  &.is-drag-over {
    &:not(.not-answered) {
      background: ${colorsV2.blue10};
      border: 1px dashed ${colorsV2.blue100};
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
        0 0 1px rgba(0, 0, 0, 0.04);
    }
    color: ${colorsV2.blue80};
    border-radius: 16px;

    .empty-drop-box {
      .question-option {
        background-color: ${colorsV2.blue20};
      }
    }
  }

  &.${QuestionDisplayMode.QUESTION_OPTION_CORRECT},
    &.${QuestionDisplayMode.QUESTION_OPTION_CORRECT_MISSING} {
    color: ${colorsV2.green100};
  }
  &.${QuestionDisplayMode.QUESTION_OPTION_WRONG} {
    color: ${colorsV2.red100};
  }
  &.${QuestionDisplayMode.QUESTION_OPTION_FADE} {
    color: ${colorsV2.gray20};
  }
  &.${QuestionDisplayMode.QUESTION_OPTION_MISSING} {
    color: ${colorsV2.yellow100};
  }

  .icon-wrapper {
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
  }
  .btn-close {
    margin-left: 8px;

    visibility: hidden;
    > .row-center {
      width: 24px;
    }
  }
  ${(p) =>
    p.isMatching &&
    css`
      &:hover {
        border: 1px solid ${colorsV2.gray20};
        box-sizing: border-box;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.04), 0 0 2px rgba(0, 0, 0, 0.06),
          0 0 1px rgba(0, 0, 0, 0.04);
        border-radius: 16px;
        .btn-close {
          visibility: visible;
        }
      }
    `}

  .question-circle {
    margin-right: 8px;
  }
`;
